import type { IconNames } from '@dixa/lib-shared-habla';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import {
  FlowNode,
  flowNodeColor,
  NodeT,
  NodeTypeComponent,
} from 'fable/flowEditor';

import { PowerChatFlowExtraDataT } from '../PowerChatFlow';
import ActionModal from '../modals/hidden';

export type FlowChatNodeHiddenTypeT = FlowNodeTypes.HIDDEN;
export type FlowChatNodeHiddenT = NodeT<FlowChatNodeHiddenTypeT>;

export class HideWidgetNode extends NodeTypeComponent<
  FlowChatNodeHiddenT,
  PowerChatFlowExtraDataT
>() {
  static icon: IconNames = 'arrow-down';
  static label = 'Hide Widget';
  static color = flowNodeColor.red;
  static ActionModal = ActionModal;
  static actionTrigger = { type: FlowNodeTypes.HIDDEN };
  static updateConnection = (node: FlowChatNodeHiddenT): FlowChatNodeHiddenT =>
    node;

  render() {
    return (
      <FlowNode
        color={HideWidgetNode.color}
        icon={HideWidgetNode.icon}
        label={HideWidgetNode.label}
      />
    );
  }
}
